import {ProductionSchedule} from '@domain/production-schedule/production-schedule';
import {ProductionSchedulePath} from '@domain/production-schedule/production-schedule-path';
import {ProductionSchedulePathsOfColoredYarnSet} from '@domain/production-schedule/production-schedule-paths-of-colored-yarn-set';
import {each, size} from 'lodash-es';

export function renameProductionSchedulePathsToNewPositionInColoredYarnSets(productionSchedule: ProductionSchedule): ProductionSchedule {
  let pathNumbering = 1;

  each(productionSchedule.productionSchedulePathsOfColoredYarnSets, (productionSchedulePathsOfColoredYarnSet: ProductionSchedulePathsOfColoredYarnSet) => {
    if (size(productionSchedulePathsOfColoredYarnSet.productionSchedulePaths) > 0) {
      each(productionSchedulePathsOfColoredYarnSet.productionSchedulePaths, (productionSchedulePath: ProductionSchedulePath) => {
        productionSchedulePath.name = `Path ${pathNumbering}`;
        productionSchedulePath.pathNumber = pathNumbering;
        pathNumbering++;
      });
    } else {
      pathNumbering++;
    }
  });

  return productionSchedule;
}
